<template>
    <footer class="app-footer" role="contentinfo">
        <div class="container-fluid app-footer__inner">
            <div class="app-footer__brand">
                <img src="/assets/icons/wob-logo-footer.png" alt="Logo der Stadt Wolfsburg" />
                <div class="app-footer__copy">
                    <div>© {{ new Date().getFullYear() }}</div>
                    <div>Bildungsbüro Wolfsburg</div>
                </div>
            </div>

            <div class="app-footer__right">
                <nav class="app-footer__links" aria-label="Footer Navigation">
                    <a href="/impressum" title="Zum Impressum">Impressum</a>
                    <a href="/datenschutz" title="Zur Datenschutzerklärung">Datenschutz</a>
                    <a href="/barrierefreiheit" title="Zur Barrierefreiheit">Barrierefreiheit</a>
                    <button class="link-like" type="button" @click="showFeedbackModal" title="Kontakt aufnehmen">
                        Kontakt
                    </button>
                </nav>

                <a :href="$loginForProvidersBaseUrl" class="app-footer__login" target="_blank"
                    rel="noopener noreferrer" title="Login für Anbietende">
                    LOGIN FÜR ANBIETENDE
                </a>
            </div>

        </div>
    </footer>
</template>

<script>
import { bus } from '@/main';

export default {
    name: 'Footer',
    methods: {
        showFeedbackModal() {
            bus.$emit('show-feedback-modal', true);
        }
    }
}
</script>
<style lang="scss" scoped>
@import '@/scss/_variables.scss';

.app-footer {
    background: #f6f7fb;
    border-top: 1px solid #e5e7ee;
    padding: 18px 0;

    @media (max-width: 991px) {
        display: none;
    }

    &__inner {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 24px;
    }

    &__brand {
        display: inline-flex;
        align-items: flex-start;
        gap: 10px;

        img {
            height: 40px;
            width: auto;
        }

        .app-footer__copy {
            display: flex;
            flex-direction: column;
            font-size: 13px;
            color: #1f2430;
            font-weight: 600;
            line-height: 1.4;
        }
    }

    &__right {
        display: inline-flex;
        align-items: center;
        gap: 24px;
    }

    &__links {
        display: inline-flex;
        align-items: center;
        gap: 18px;
        flex-wrap: wrap;

        a,
        .link-like {
            font-size: 13px;
            color: #1f2430;
            font-weight: 700;
            text-transform: none;
            text-decoration: none;
            background: transparent;
            border: none;
            padding: 6px 0;
            cursor: pointer;

            &:hover,
            &:focus-visible {
                color: $primary;
                text-decoration: none;
                outline: none;
            }
        }
    }

    &__login {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 18px;
        border-radius: 999px;
        background: #3755a6;
        color: #ffffff;
        font-weight: 800;
        font-size: 13px;
        letter-spacing: 0.02em;
        text-decoration: none;
        border: 1px solid rgba(0, 0, 0, 0.06);
        box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
        white-space: nowrap;

        &:hover,
        &:focus-visible {
            background: #2f4991;
            text-decoration: none;
            outline: 2px solid rgba(55, 85, 166, 0.4);
            outline-offset: 2px;
        }
    }
}
</style>